/**
 * useReportsUnreadCount — Hook pour suivre le nombre de signalements
 * de l'utilisateur avec des messages admin non lus.
 *
 * Utilisé par le sidebar (AppShell) pour afficher un badge "X non lus"
 * à côté du lien "Mes signalements".
 *
 * Rafraîchi toutes les 60 secondes.
 *
 * Pour les admins : utilise getAdminReportsUnreadTotal (signalements
 * avec messages user non lus côté admin).
 */

import { useState, useEffect } from "react";
import { getMyReportsUnreadCount, getAdminReportsUnreadTotal } from "@/lib/api";

const POLL_INTERVAL_MS = 60000;


export function useMyReportsUnreadCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const fetchCount = async () => {
      try {
        const r = await getMyReportsUnreadCount();
        if (!cancelled) setCount(r.data?.total || 0);
      } catch {
        // Silent fail — pas d'erreur utilisateur pour un compteur secondaire
      }
    };
    fetchCount();
    const interval = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return count;
}


export function useAdminReportsUnreadCount(enabled = true) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    let cancelled = false;
    const fetchCount = async () => {
      try {
        const r = await getAdminReportsUnreadTotal();
        if (!cancelled) setCount(r.data?.total || 0);
      } catch {
        // Silent fail
      }
    };
    fetchCount();
    const interval = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [enabled]);

  return count;
}
